import { NextSeo } from 'next-seo'
import LaunchChallenge from 'views/LaunchChallenge'

const Page = () => (
  <>
    <NextSeo title="CADINU Launch Challenge: apply" description="Apply for up to $30,000 of support for three projects launched through CAD1. Applications open October 15, 2026." />
    <LaunchChallenge />
  </>
)
// Readable on every wallet chain: nothing here touches a wallet.
Page.chains = []
export default Page
